/* eslint-disable import/no-named-as-default */
/* eslint-disable no-shadow */
import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import Fab from '@material-ui/core/Fab';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ConfirmationDialog from '../../components/ConfirmationDialog';
import UserClientTable from '../../components/UserClientTable';
import ClientForm from '../AdminClientForm';
import Loading from '../../components/Loading';

import {
  getUser,
  editUser,
  deleteUser,
  setUserClient,
  deleteUserClient,
  updateUser,
  changeUserPassword,
} from '../../actions/users';
import UserInfoGrid from '../../components/UserInfoGrid';
import UserLogsTable from '../../components/UserLogsTable';

const useStyles = makeStyles(theme => ({
  hide: {
    display: 'none',
  },
  wrapper: {
    marginTop: theme.spacing(3),
  },
  title: {
    padding: theme.spacing(2),
  },
  loading: {
    marginTop: theme.spacing(7),
    position: 'fixed',
    left: '50%',
  },
  fab: {
    width: '60px',
    height: '60px',
    bottom: '30px',
    right: '10px',
  },
}));

export const UserDetail = props => {
  const {
    match,
    isEditing,
    selectedUser,
    isLoading,
    getUser,
    deleteUser,
    changeUserPassword,
    setUserClient,
    deleteUserClient,
    updateUser,
    data,
    clients,
    epiAccess,
  } = props;

  const classes = useStyles();
  const userId = match.params.id;
  const [anchorEl, setAnchorEl] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [secondDialogOpen, setSecondDialogOpen] = useState(false);

  useEffect(() => {
    getUser(userId);
  }, [getUser, userId]);

  return (
    <>
      <Loading />
      {isEditing ? <ClientForm client={selectedUser} /> : null}
      <Container
        className={clsx(classes.wrapper, {
          [classes.hide]: isEditing,
        })}
        maxWidth="lg"
      >
        <CircularProgress
          className={clsx(classes.loading, {
            [classes.hide]: !isLoading,
          })}
        />
        <Grid>
          <Grid container item xs={12} spacing={0} wrap="nowrap">
            <Typography className={classes.title} variant="h5" component="h3" sm={8}>
              User
            </Typography>
          </Grid>
        </Grid>
        <div className={clsx({ [classes.hide]: isLoading })}>
          <UserInfoGrid user={selectedUser} updateUser={updateUser} epiAccess={epiAccess} />
        </div>

        <Grid
          container
          justify="flex-end"
          className={clsx({
            [classes.hide]: isLoading,
          })}
        >
          <div>
            <Fab
              color="primary"
              aria-label="actions"
              className={classes.fab}
              aria-controls="long-menu"
              aria-haspopup="true"
              onClick={event => setAnchorEl(event.currentTarget)}
            >
              <MoreVertIcon />
            </Fab>
            <Menu
              getContentAnchorEl={null}
              id="action-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={() => setAnchorEl(null)}
              variant="selectedMenu"
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
            >
              <MenuItem
                onClick={() => {
                  setAnchorEl(null);
                  setDialogOpen(true);
                }}
              >
                Delete User
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setAnchorEl(null);
                  setSecondDialogOpen(true);
                }}
              >
                Change User Password
              </MenuItem>
            </Menu>
          </div>
        </Grid>
        <UserClientTable
          user={selectedUser}
          deleteUserClient={deleteUserClient}
          setUserClient={setUserClient}
          data={data}
          clients={clients}
          access={epiAccess}
        />
        <UserLogsTable userId={match.params.id} />
      </Container>

      <ConfirmationDialog
        title="Delete User?"
        description={`Are you sure you want to delete user ${selectedUser.id}? This action cannot be undone.`}
        primaryButtonText="Delete"
        onPrimaryButtonClick={() => {
          deleteUser(selectedUser.id);
        }}
        secondaryButtonText="Cancel"
        onSecondaryButtonClick={() => setDialogOpen(false)}
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />
      <ConfirmationDialog
        title="Force Password Change?"
        description={`Are you sure you want to change user ${selectedUser.id} password? This action cannot be undone.`}
        primaryButtonText="Change Password"
        onPrimaryButtonClick={() => {
          changeUserPassword(selectedUser.email);
          setSecondDialogOpen(false);
        }}
        secondaryButtonText="Cancel"
        onSecondaryButtonClick={() => setSecondDialogOpen(false)}
        open={secondDialogOpen}
        onClose={() => setSecondDialogOpen(false)}
      />
    </>
  );
};

UserDetail.defaultProps = {
  selectedUser: {},
  isEditing: false,
  match: {},
  isLoading: false,
  getUser: () => {},
  deleteUser: () => {},
  changeUserPassword: () => {},
  setUserClient: () => {},
  deleteUserClient: () => {},
  updateUser: () => {},
  data: [],
  clients: [],
  epiAccess: {},
};

UserDetail.propTypes = {
  selectedUser: PropTypes.shape({
    id: PropTypes.number,
    email: PropTypes.string,
    createdAt: PropTypes.string,
    linesOfBusiness: PropTypes.arrayOf(PropTypes.string),
    clients: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
      })
    ),
    defaultBusinessLineId: PropTypes.number,
    // roles: PropTypes.shape({
    //   app: PropTypes.arrayOf(PropTypes.string),
    // }),
  }),
  isEditing: PropTypes.bool,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
  getUser: PropTypes.func,
  isLoading: PropTypes.bool,
  deleteUser: PropTypes.func,
  setUserClient: PropTypes.func,
  deleteUserClient: PropTypes.func,
  updateUser: PropTypes.func,
  changeUserPassword: PropTypes.func,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      billingAddressLine1: PropTypes.string,
      billingAddressLine2: PropTypes.string,
      billingAddressZip: PropTypes.string,
      billingAddressState: PropTypes.string,
      billingAddressCity: PropTypes.string,
    })
  ),
  clients: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      meta: PropTypes.shape({
        users: PropTypes.arrayOf(PropTypes.string),
        subscriptions: PropTypes.arrayOf(PropTypes.string),
        privileges: PropTypes.arrayOf(PropTypes.string),
      }),
    })
  ),
  epiAccess: PropTypes.shape({
    isInternal: PropTypes.bool,
    isAdmin: PropTypes.bool,
  }),
};

const mapStateToProps = state => {
  const { users, clients, auth } = state;
  return {
    selectedUser: users.selectedUser,
    isLoading: users.isLoading,
    isEditing: users.isEditing,
    data: clients.data,
    clients: clients.clients,
    approles: clients.approles,
    apps: clients.apps,
    epiAccess: auth.profile[process.env.REACT_APP_APP_METADATA_KEY].episourceAccess,
  };
};

const mapDispatchToProps = {
  getUser,
  editUser,
  deleteUser,
  changeUserPassword,
  setUserClient,
  deleteUserClient,
  updateUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserDetail);
